import { returnVariantDataLayerObject } from '.';

export const pushProductVariantDetailsToDataLayer = (variant) => {
  const dataLayerData = {
    event: 'ProductDetailView',
    ecommerce: {
      pageCategory: 'details',
      detail: {
        products: [],
      },
    },
  };

  const productItem = returnVariantDataLayerObject(variant);

  // Push product information to google analytics.
  if (typeof ga !== 'undefined') {
    ga('require', 'ec');
    ga('ec:addImpression', productItem);
    ga('ec:setAction', 'detail');
  }

  dataLayerData.ecommerce.detail.products.push(productItem);

  if (typeof dataLayer === 'undefined') {
    return;
  }

  dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
  dataLayer.push(dataLayerData);
};
